import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertasService {
  exibirAlerta = false;
  mensagemTexto;
  constructor() { }

  exibir(txtMensagem): void {
    this.exibirAlerta = true;
    this.mensagemTexto = txtMensagem;
  }

  fechar(): void {
    this.exibirAlerta = false;
  }
}
